import { useState, useCallback, useEffect } from "react"
import { LocationStatus, V2L3LocationModal } from "@fusion-advantage/formrender"
import { DateTime } from "luxon"
import { useAppDispatch, useAppSelector, useAppStore } from "../../../redux/hooks"
import { AppModal, dismissAppModal, setAppContent } from "../../../redux/appSlice"
import { selectLocationStatus, setLocationNextModalSkipContent } from "../../../redux/locationSlice"
import { serializeFusionError } from '@fusion-advantage/backcompat'
import { proposeContentLoadIgnoreLocation, RootRouteFormContent } from "@fusion-advantage/formlib"
import { locationMwTick } from "../../../redux/locationMw"
import { appError } from "../../../redux/errorSlice"
import { requestLocationPermissions } from "../../../lib/location"

export const LxLocationModal = () => {
	const store = useAppStore()
	const status = useAppSelector(selectLocationStatus)
	const [skipContent, setSkipContent] = useState<RootRouteFormContent|null>(null)
	const env = useAppSelector(state => state.app.environment)
	const dispatch = useAppDispatch()
	useEffect(() => {
		// when the modal opens, grab any nextModalSkipContent
		// for use by the skip button
		let skipContent = store.getState().location.nextModalSkipContent
		if(skipContent) {
			if(proposeContentLoadIgnoreLocation(skipContent, env).isOk()) {
				setSkipContent(skipContent)
			}
			dispatch(setLocationNextModalSkipContent(null))
		}
	}, [dispatch])
	const handleSkipClick = useCallback(() => {
		if(!skipContent) {
			dispatch(appError({
				err: serializeFusionError('LxLocationModal', 'expected skipContent but null')
			}))
			return
		}
		dispatch(dismissAppModal(AppModal.Location))
		dispatch(setAppContent(skipContent))
	}, [skipContent, dispatch])
	const handleRequestAccessClick = useCallback(async () => {
		const r = await requestLocationPermissions()
		if(r.isErr() && r.error.error) {
			dispatch(appError({
				err: r.error.error,
				suppressAlert: true,
			}))
		}
		await dispatch(locationMwTick())
		const nextStatus = store.getState().location.result?.status
		if(r.isOk() && nextStatus === LocationStatus.Success) {
			dispatch(dismissAppModal(AppModal.Location))
		}
	}, [dispatch, store])
	return (
		<V2L3LocationModal
			status={status}
			lastUpdatedAt={DateTime.now()}
			canSkip={Boolean(skipContent)}
			onRefreshClick={() => dispatch(locationMwTick())}
			onSkipClick={handleSkipClick}
			onRequestAccessClick={handleRequestAccessClick}
			onDismissClick={() => dispatch(dismissAppModal(AppModal.Location))}
		/>
	)
}
